import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SignalRMaster } from '@app/Modules/Shared/Services/SingnalR.master.service';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { CpAgGridService } from '@app/Modules/cp-grid/services/cp-ag-grid-service';
import { AgRendererComponent } from 'ag-grid-angular';
import { IpRefreshService } from '@app/Modules/Shared/Services/ip-refresh.service';

@Component({
  selector: 'app-ipcustomers',
  templateUrl: './ipcustomers.component.html',
  styleUrls: ['./ipcustomers.component.scss']
})
export class IPCustomersComponent implements AgRendererComponent, OnDestroy {

  params: any;
  content: boolean = false;
  displayCustomerListModal: boolean = false;
  custIDs: any = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private httpServ: HttpService,
    private gridService: CpAgGridService,
    private appserv: AppService,
    private globalAppService: GlobalAppService,
    private signalRService: SignalRMaster,
    private ipService: IpRefreshService ) { }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params.value;
    if (this.params != "N/A") {
      this.content = true;
      this.custIDs = this.params;
    }
    else {
      this.content = false;
    }
  }

  refresh(params: any): boolean {
    return false;
  }

  onLinkClick() {
    this.custIDs = this.params.split(",");
    this.ipService.setCustomerDetails(this.custIDs);
    this.ipService.queueCustomerPopup();
  }

  ngOnDestroy() {

  }

  closedCustModal(event) {
    this.displayCustomerListModal = event.close === "true";
  }

}
